export enum QuestionTypeEnum {
  MultipleChoice = 1,
  MultipleResponse = 2,
  OpenResponse = 3,
  ChoosePicture = 4,
  Essay = 5,
}
